import React from "react";

export default function useWindowSize() {
    const isSSR = typeof window === "undefined";
    const [windowSize, setWindowSize] = React.useState({
        windowWidth: isSSR ? 1281 : window.innerWidth,
        windowHeight: isSSR ? 801 : window.innerHeight,
    });

    function changeWindowSize() {
        setWindowSize({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
    }

    React.useEffect(() => {
        window.addEventListener("resize", changeWindowSize);

        return () => {
            window.removeEventListener("resize", changeWindowSize);
        };
    }, []);

    return windowSize;
}